<template>
  <ion-app>
    <!-- Wrapped in <top-layer> so the loader paints above any open Vivid modal
         dialog, which lives in the browser's native top layer. -->
    <top-layer :visible="isLoading">
      <vonage-loader
        v-if="isLoading"
        :message="loadingMessage"
      />
    </top-layer>

    <!-- <div v-if="showIntro" class="intro-overlay">
      <Intro @finish="() => { showIntro = false; Storage.set({ key: 'showIntro', value: false }); }" :steps="steps"></Intro>
      <ion-menu-toggle ref="menuToggle" style="visibility: hidden;">
        <ion-button style="opacity: 0; pointer-events: none;">Click to open the menu</ion-button>
      </ion-menu-toggle>
    </div> -->
    <ion-split-pane content-id="main-content" when="md" :class="{ sideNavClosed: closeSideBar }" class="sideNav">
      <ion-menu id="app-menu" v-show="loginStatus === 'success'" content-id="main-content" class="sideMenu">
        <ion-list v-if="permissions" id="inbox-list">
          <ion-list-header class="outer-list">
            <ion-label @click.stop="() => closeSideBar = false">
              <img @click="$router.push('/dashboard')" width="30" :src="require('/src/resources/images/jumper_logo_icon_color.svg')" />
            </ion-label>
            <ion-button @click.stop="() => closeSideBar = true" id="menu-button" class="label ion-hide-lg-down">
              <img :src="!isDarkMode ? require('/src/resources/images/back.svg') : require('/src/resources/images/back-dark.svg')" width="20" />
            </ion-button>
          </ion-list-header>
          <div class="complete-list">
            <ion-menu-toggle autoHide="false">
              <ion-item @click="$router.push('/dashboard')" lines="none" detail="false" :class="thisRouterPath === '/dashboard' ? 'active-link' : 'sidebar-title'">
                <VIcon name="home-line" :size="-5" class="icon cursorPointer"></VIcon>
                <ion-label class="label">Dashboard</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle v-if="canAccessPath('/page-inbox')" autoHide="false">
              <ion-item @click="$router.push('/page-inbox')" lines="none" detail="false" :class="{ 'active-link': thisRouterPath === '/page-inbox', 'sidebar-title': thisRouterPath !== '/page-inbox' }">
                <VIcon name="message-line" :size="-5" class="icon cursorPointer"></VIcon>
                <ion-label class="label">Live Chat</ion-label>
                <div v-if="newChat" class="redDot"></div>
              </ion-item>
            </ion-menu-toggle>

            <ion-accordion-group class="hide-on-mobile">
              <ion-accordion v-if="canAccessPath('/developer-portal/applications')" value="Developer Portal">
                <ion-item
                  @click="closeSideBar = false"
                  slot="header"
                  lines="none"
                >
                  <VIcon
                    slot="start"
                    name="code-line"
                    :size="-5"
                    class="icon cursorPointer"
                  ></VIcon>
                  <ion-text class="label sidebar-title"
                    >Developer Portal</ion-text
                  >
                </ion-item>
                <div slot="content" class="sidebar-children ion-no-padding">
                  <ion-menu-toggle autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/developer-portal/applications' ? 'active-link' : 'sidebar-title'">
                      <ion-label
                        @click="$router.push('/developer-portal/applications')"
                        class="label ion-no-margin"
                        >Applications</ion-label
                      >
                    </div>
                  </ion-menu-toggle>
                  <ion-menu-toggle autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/developer-portal/api-reference' ? 'active-link' : 'sidebar-title'">
                      <ion-label
                        @click="$router.push('/developer-portal/api-reference')"
                        class="label ion-no-margin"
                        >API Reference</ion-label
                      >
                    </div>
                  </ion-menu-toggle>
                  <ion-menu-toggle @click="$router.push('/developer-portal/analytics')" :class="thisRouterPath === '/developer-portal/analytics' ? 'active-link' : 'sidebar-title'" autoHide="false">
                    <div class="sidebar-children-text" >
                      <ion-label class="label ion-no-margin">Analytics</ion-label>
                    </div>
                  </ion-menu-toggle>
                  <ion-menu-toggle  @click="$router.push('/developer-portal/settings')" :class="thisRouterPath === '/developer-portal/settings' ? 'active-link' : 'sidebar-title'" autoHide="false">
                    <div class="sidebar-children-text">
                      <ion-label class="label ion-no-margin">Settings</ion-label>
                    </div>
                  </ion-menu-toggle>
                </div>
              </ion-accordion>
            </ion-accordion-group>

            <ion-menu-toggle v-if="canAccessPath('/bot-builder')" autoHide="false" class="hide-on-mobile">
              <ion-item @click="$router.push({ path: '/bot-builder', query: { folderid: 'default' } })" lines="none" detail="false" :class="{ 'active-link': thisRouterPath === '/bot-builder', 'sidebar-title': thisRouterPath !== '/bot-builder' }">
                <VIcon name="bot-line" :size="-5" class="icon"></VIcon>
                <ion-label class="label">Bot Builder</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle v-if="canAccessPath('/broadcast')" autoHide="false" class="hide-on-mobile">
              <ion-item @click="$router.push('/broadcast')" lines="none" detail="false" :class="{ 'active-link': thisRouterPath === '/broadcast', 'sidebar-title': thisRouterPath !== '/broadcast' }">
                <VIcon name="megaphone-line" :size="-5" class="icon"></VIcon>
                <ion-label class="label">Broadcast</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-accordion-group class="hide-on-mobile">
              <ion-accordion v-if="canAccessAnyPath(['/customers', '/customers/segments'])" value="customers">
                <ion-item @click="closeSideBar = false" slot="header" lines="none">
                  <VIcon slot="start" name="group-line" :size="-5" class="icon"></VIcon>
                  <ion-text class="label sidebar-title">Customers</ion-text>
                </ion-item>
                <div slot="content" class="sidebar-children ion-no-padding">
                  <ion-menu-toggle v-if="canAccessPath('/customers')" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/customers' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/customers')" class="label ion-no-margin">Customers</ion-label>
                    </div>
                  </ion-menu-toggle>
                  <ion-menu-toggle v-if="canAccessPath('/customers/segments')" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/customers/segments' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/customers/segments')" class="label ion-no-margin">Segments</ion-label>
                    </div>
                  </ion-menu-toggle>
                </div>
              </ion-accordion>

              <ion-accordion v-if="salesChannelMenuToShow.length > 0" value="salesChannel" class="hide-on-mobile">
                <ion-item slot="header" lines="none">
                  <VIcon slot="start" name="apps-line" :size="-5" @click="closeSideBar = false" class="icon"></VIcon>
                  <ion-text class="label sidebar-title">Channels</ion-text>
                </ion-item>
                <div slot="content" class="sidebar-children ion-no-padding">
                  <ion-menu-toggle autoHide="false">
                    <div v-for="(channel, index) in salesChannelMenuToShow" :key="index">
                      <div class="sidebar-children-text" :class="thisRouterPath === channel.route ? 'active-link' : 'sidebar-title'">
                        <ion-label @click="$router.push(channel.route)" class="label ion-no-margin">{{ channel.title  }}</ion-label>
                      </div>
                    </div>
                  </ion-menu-toggle>
                </div>
              </ion-accordion>

              <!-- || permissions.engagement -->
              <ion-accordion v-if="canAccessAnyPath(['/analytics/broadcast', '/analytics/customers'])" value="analytics" class="hide-on-mobile">
                <ion-item @click="closeSideBar = false" slot="header" lines="none">
                  <VIcon slot="start" name="chart-line" :size="-5" class="icon"></VIcon>
                  <ion-text class="label sidebar-title">Analytics</ion-text>
                </ion-item>
                <div slot="content" class="sidebar-children ion-no-padding">
                  <ion-menu-toggle v-if="canAccessPath('/analytics/broadcast')" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/analytics/broadcast' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/analytics/broadcast')" class="label ion-no-margin">Broadcasts</ion-label>
                    </div>
                  </ion-menu-toggle>
                  <ion-menu-toggle v-if="canAccessPath('/analytics/customers')" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/analytics/customers' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/analytics/customers')" class="label ion-no-margin">Customers</ion-label>
                    </div>
                  </ion-menu-toggle>
                  <ion-menu-toggle v-if="permissions.livechat" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/analytics/livechat' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/analytics/livechat')" class="label ion-no-margin">Agents</ion-label>
                    </div>
                  </ion-menu-toggle>
                  <!-- <ion-menu-toggle v-if="permissions.googlercs && googlercsConnected" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/analytics/rcs' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/analytics/rcs')" class="label ion-no-margin">RCS</ion-label>
                    </div>
                  </ion-menu-toggle> -->
                  <!-- <ion-menu-toggle v-if="permissions.engagement" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/analytics/engagement' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/analytics/engagement')" class="label ion-no-margin">Engagement</ion-label>
                    </div>
                  </ion-menu-toggle> -->
                </div>
              </ion-accordion>
            </ion-accordion-group>

            <ion-accordion-group>
              <ion-accordion v-if="canAccessAnyPath(['/settings/account', '/settings/team', '/settings/live-chat', '/settings/password', '/settings/data-privacy', '/settings/sso', '/integrations'])" value="settings">
                <ion-item @click="$router.push('/settings')"  slot="header" lines="none" :class="thisRouterPath === '/settings' ? 'active-link' : 'sidebar-title'">
                  <VIcon slot="start" name="gear-line" :size="-5" class="icon"></VIcon>
                  <ion-text class="label sidebar-title"> Settings </ion-text>
                </ion-item>
                <div slot="content" class="sidebar-children ion-no-padding">
                  <ion-menu-toggle v-if="canAccessPath('/settings/account')" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/settings/account' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/settings/account')" class="label ion-no-margin">Business Profile</ion-label>
                    </div>
                  </ion-menu-toggle>

                  <ion-menu-toggle v-if="canAccessPath('/settings/team')" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/settings/team' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/settings/team')" class="label ion-no-margin">Team Members</ion-label>
                    </div>
                  </ion-menu-toggle>

                  <ion-menu-toggle v-if="canAccessPath('/settings/live-chat')" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/settings/live-chat' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/settings/live-chat')" class="label ion-no-margin">Live Chat Settings</ion-label>
                    </div>
                  </ion-menu-toggle>

                  <ion-menu-toggle v-if="canAccessPath('/settings/password')" autoHide="false">
                    <div class="sidebar-children-text" :class="thisRouterPath === '/settings/password' ? 'active-link' : 'sidebar-title'">
                      <ion-label @click="$router.push('/settings/password')" class="label ion-no-margin">Password Settings</ion-label>
                    </div>
                  </ion-menu-toggle>

                  <ion-menu-toggle v-if="canAccessPath('/settings/data-privacy')" autoHide="false">
                    <div class="sidebar-children-text" :class="{ 'active-link': thisRouterPath === '/settings/data-privacy', 'sidebar-title': thisRouterPath !== '/settings/data-privacy' }">
                      <ion-label @click="$router.push('/settings/data-privacy')" class="label ion-no-margin">Data Privacy</ion-label>
                    </div>
                  </ion-menu-toggle>

                  <ion-menu-toggle v-if="canAccessPath('/settings/sso')" autoHide="false">
                    <div class="sidebar-children-text" :class="{ 'active-link': thisRouterPath === '/settings/sso', 'sidebar-title': thisRouterPath !== '/settings/sso' }">
                      <ion-label @click="$router.push('/settings/sso')" class="label ion-no-margin">SSO Settings</ion-label>
                    </div>
                  </ion-menu-toggle>

                  <!-- NOTE: When adding new integrations, include them in the conditional check (e.g., v-if="permissions.addons?.moengage || permissions.addons?.newIntegration") -->
                  <ion-menu-toggle autoHide="false" v-if="canAccessPath('/integrations')">
                    <div class="sidebar-children-text" :class="{ 'active-link': thisRouterPath.startsWith('/integrations'), 'sidebar-title': !thisRouterPath.startsWith('/integrations') }">
                      <ion-label @click="$router.push('/integrations')" class="label ion-no-margin">Integrations</ion-label>
                    </div>
                  </ion-menu-toggle>
                </div>
              </ion-accordion>
            </ion-accordion-group>

            <ion-menu-toggle autoHide="false" class="hide-on-mobile">
              <ion-item @click="$router.push('/account/edit-profile')" lines="none" detail="false" :class="thisRouterPath === '/account/edit-profile' ? 'active-link' : 'sidebar-title'">
                <VIcon name="profile-line" :size="-5" class="icon"></VIcon>
                <ion-label class="label">Edit profile</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </div>
          <div class="bottom-panel">
            <!-- <div class="dark-mode" id="dark-mode">
              <ion-item lines="none" detail="false">
                <VIcon name="contrast" :size="-5" @click="() => isDarkMode = !isDarkMode" class="icon"></VIcon>
                <ion-label slot="start" class="label">
                  <div class="sidebar-title">Dark mode</div>
                  <div class="version">v {{ version }}</div>
                </ion-label>
                <ion-toggle class="label" slot="end" v-model="isDarkMode" aria-label="isDarkMode"></ion-toggle>
              </ion-item>
            </div> -->
            <div v-if="closeSideBar" class="outer-version">
              <span class="version">(v {{ version }})</span>
            </div>
            <div class="customer-profile" id="customer-profile">
              <div class="profile" @click="() => accounts.length ? switchAccountMode = true : 0">
                <img :src="getShopLogoImage" class="cust-img"/>
                <div class="description">
                  <div class="shopName">{{ user?.shopName }}</div>
                  <div class="email">{{ roleDetails?.email }}</div>
                </div>
              </div>
            </div>
            <ion-menu-toggle autoHide="false">
              <ion-item @click="logout" lines="none" detail="false" class="sidebar-title">
                <VIcon name="exit-line" :size="-5" class="icon"></VIcon>
                <ion-label class="label">
                  <span>Logout</span>
                  <span class="version">(v {{ version }})</span>
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </div>
        </ion-list>
      </ion-menu>
      <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-split-pane>
    <!--
      The toast cannot use <top-layer> the way the loader does: Ionic's overlay
      delegate *teleports* an inline overlay out of its authored position and
      appends it to <ion-app> when it is presented (leaving an "ionic teleport"
      comment behind). So any wrapper element we author around <ion-toast> is
      empty by the time the toast is on screen.
      Instead the toast element is promoted into the top layer itself: it is a
      manual popover and we call showPopover() on it once Ionic has finished
      moving it (willPresent). Because top layer paint order follows entry
      order, promoting it at present time puts it above any modal Vivid dialog
      that was already open. Ionic detaches the element on dismiss, which
      implicitly removes it from the top layer again.
    -->
    <ion-toast
      ref="globalToast"
      popover="manual"
      :is-open="toast.open"
      :message="toast.message"
      :duration="toast.duration"
      :color="toast.type"
      @willPresent="promoteToastToTopLayer"
      @didDismiss="demoteToastFromTopLayer"
    >
    </ion-toast>

    <ion-modal ref="showReportIssueModal" :is-open="showReportIssue" @willDismiss="() => showReportIssue = false" class="showReportIssueModal" data-html2canvas-ignore="true">
      <ion-header>
        <ion-toolbar>
          <ion-title class="header">Report Issue</ion-title>
          <ion-buttons slot="end">
            <ion-button @click="() => showReportIssue = false">Cancel</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content :class="{'overflow-hidden': loadingJiraIssue}">
        <div v-if="loadingJiraIssue" class="jira-loader-overlay">
          <ion-spinner name="lines-small"></ion-spinner>
        </div>
        <ion-list>
          
          <ion-item lines="none">
            <div class="item-col">
              <p class="sub-title ion-no-margin paddingBottom">When you noticed this issue, what were you trying to do?<span class="important">*</span></p>
              <my-input
                aria-label="When you noticed this issue, what were you trying to do"
                textarea
                id="testIssue"
                :rows="2"
                name="testIssue"
                placeholder="E.g., I was trying to send a broadcast message to customers..." 
                :value="newIssue.subject"
                @onInput="(prop) =>newIssue.subject = prop"
                :maxlength="100"
                lengthCounter
                class="name-input"
                :lengthStyle="{right: '10px'}"
                :inputStyle="{marginLeft: '0px', marginRight: '0px'}"
              />
            </div>
          </ion-item>
          <ion-item lines="none">
            <div class="item-col">
              <p class="sub-title ion-no-margin paddingBottom">Tell us your name<span class="important">*</span></p>
              <my-input
                aria-label="Tell us your name"
                textarea
                id="nameIssue"
                :rows="2"
                name="nameIssue"
                placeholder="Enter your name" 
                :value="newIssue.name"
                @onInput="(prop) => newIssue.name = prop"
                :maxlength="100"
                lengthCounter
                class="name-input"
                :lengthStyle="{right: '10px'}"
                :inputStyle="{marginLeft: '0px', marginRight: '0px'}"
              />
            </div>
          </ion-item>
          <ion-item lines="none">
            <div class="item-col">
              <ion-label class="sub-title">Describe your issue</ion-label>
              <my-input
                aria-label="describe your issue"
                textarea
                id="describeIssue"
                :rows="4"
                name="describeIssue"
                placeholder="Please describe the issue" 
                :value="newIssue.description"
                @onInput="(prop) => newIssue.description = prop"
                :maxlength="1000"
                lengthCounter
                class="issue-input"
                :lengthStyle="{right: '10px'}"
                :inputStyle="{marginLeft: '0px', marginRight: '0px'}"
              />
            </div>
          </ion-item>
          <div class="info-box">
            <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
            <p class="info-text ion-no-margin">Please do not include any sensitive information.</p>
          </div>
          <ion-item lines="none">
            <div class="item-col">
              <ion-label class="sub-title">A screenshot will help us better understand the issue. (optional)</ion-label>
              <ion-list v-if="generatingPreview || newIssue.images?.length" class="images">
                <div v-if="generatingPreview" class="ion-text-center" style="padding: 10px;">
                  <ion-spinner name="lines-small"></ion-spinner>
                  <div style="margin-top: 8px; font-size: 14px;">Generating screenshot preview...</div>
                </div>

                <div v-else v-for="(img, iIndex) in newIssue.images" :key="iIndex" class="img">
                  <ion-img :src="img.url" />
                  <VIcon
                    @click.stop="newIssue.images.splice(iIndex, 1); screenshotFile = null;"
                    name="delete-line"
                    connotation="alert"
                    class="delete-icon"
                  />
                </div>
              </ion-list>
              <ion-buttons>
              <ion-button @click="captureScreenshot" class="bttnSecondary" :disabled="generatingPreview" >
                <ion-spinner slot="start" name="dots" v-if="generatingPreview" style="width: 16px; height: 16px;" />
                <VIcon name="camera-line" :size="-5" v-else style="padding-right: 10px" />
                {{ generatingPreview ? 'Capturing...' : 'Capture screenshot' }}
              </ion-button>
            </ion-buttons>
            </div>
          </ion-item>
        </ion-list>
      </ion-content>
      <ion-footer>
        <ion-toolbar class="fxd_btm_block">
          <div class="footerBttn">
            <ion-button size="default" fill="solid" @keyup.enter="submitJiraIssue" :disabled="!newIssue.name || !newIssue.subject || loadingJiraIssue" @click.stop="submitJiraIssue" class="bttnPrimary">Submit</ion-button>
          </div>
        </ion-toolbar>
      </ion-footer>
    </ion-modal>

    <ion-modal ref="switchAccountModal" :is-open="switchAccountMode" @willDismiss="() => switchAccountMode = false">
      <ion-header>
        <ion-toolbar>
          <ion-title>Switch Account</ion-title>
          <ion-buttons slot="end">
            <ion-button @click="() => switchAccountMode = false">Cancel</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-item v-for="(thisAccount, aIndex) in accounts.filter(e => e.shop_name !== user?.shopName)" :key="aIndex" lines="none" @click="chooseLoginAccount(thisAccount.shop_name)" class="promotionAccordion">
          <ion-avatar slot="start">
            <img src="@/resources/images/shop-image-placeholder.png" loading="lazy" class="img-responsive" />
          </ion-avatar>
          <ion-label>
            <h2 class="title custPadding shop">{{ thisAccount.shop_name }}</h2>
          </ion-label>
          <VIcon name="chevron-right-line" :size="-5" class="forwardIcon" />
        </ion-item>
      </ion-content>
    </ion-modal>
    <ion-modal ref="offlineModal" :is-open="offlineMode" :backdropDismiss="false" class="offlineModalWrapper">
      <ion-content class="ion-padding offlineModal">
        <div class="image">
          <img src="data:image/png;base64,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" class="img-responsive" />
        </div>
        <div class="heading">Connection Lost</div>
        <div class="sub-text">Please wait while we're trying to reconnect you automatically!</div>
      </ion-content>
    </ion-modal>
    <ion-modal ref="legacyVersionModal" :is-open="isLoggedIn && !isPlatformLiteVersion" :backdropDismiss="false" class="offlineModalWrapper isPlatformLiteVersion">
      <ion-content class="ion-padding offlineModal">
        <div class="heading">You're on legacy version of Jumper</div>
        <div class="sub-text">Please <a :href="`https://${environment('VUE_APP_OLD_UI_DOMAIN')}`" target="_blank">Click here</a> to login to legacy dashboard<!-- , or <a :href="`https://${environment('VUE_APP_OLD_UI_DOMAIN')}`" target="_blank">Click here</a> to raise a support ticket to migrate to Jumper -->.</div>
        <div v-if="accounts?.length > 1" class="sub-text">Switched to a legacy account by mistake? <a @click="() => switchAccountMode = true">Switch back</a> to another account.</div>
        <div class="sub-text danger">Or <a @click="logout">Logout</a> instead.</div>
      </ion-content>
    </ion-modal>
    <transition name="fade">
      <div v-if="showTooltip" ref="tooltip" class="tooltip-box" :style="tooltipStyle" @mouseenter="tooltipHovered = true" @mouseleave="() => { showTooltip = false; tooltipHovered = false; }">
        <div class="tooltip-content">
          <component v-for="(child, cIndex) in tooltipSlot" :key="cIndex" :is="child"></component>
        </div>
      </div>
    </transition>  
  </ion-app>
</template>

<script>
import { IonApp, IonIcon, IonItem, IonLabel, IonList, IonListHeader,IonToggle, IonMenu, IonRouterOutlet, IonSplitPane, IonToast, IonAccordion, IonAccordionGroup, IonMenuToggle, IonTextarea } from '@ionic/vue';
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { useUIStore } from '@/stores/ui';
import { useRoleDetails } from '@/composables/useRoleDetails';
import { environment } from '@/shared/env.js';
import { getShopLogoImage as _getShopLogoImage } from '@/helpers/user.helpers';
import { canAccessRoutePath } from '@/shared/access-control';
import packageJson from '/package.json';
import uploadFilesV2 from '@/components/uploadFilesV2.vue';
import html2canvas from 'html2canvas';
import apiInterceptor from '@/shared/apiInterceptor';
import { Preferences as Storage } from '@capacitor/preferences';
import VonageLoader from '@/components/VonageLoader.vue';
import TopLayer from '@/components/TopLayer.vue';
//import Intro from "/src/components/Intro.vue";
export default defineComponent({
  name: 'App',
  components: {
    IonApp, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonMenu, IonRouterOutlet, IonSplitPane, IonToast, IonToggle,IonAccordion, IonAccordionGroup, IonMenuToggle, uploadFilesV2, IonTextarea, VonageLoader, TopLayer
  },
  async mounted(){
    window.addEventListener("offline", (e) => {
      this.offlineMode = true;
      useUIStore().updateToast({
        open: true,
        message: "Internet Connection Lost",
        type: "danger",
      });
    });

    window.addEventListener("online", (e) => {
      this.offlineMode = false;
      useUIStore().updateToast({
        open: true,
        message: "Your internet connection is restored",
        type: "success",
      });
    });

    /* if(this.$route.path.includes("login")) this.showIntro = false;
    else {
      const showIntro = JSON.parse((await (this.Storage.get({key: 'showIntro'}))).value);
      if(showIntro === false) this.showIntro = false;
      else this.showIntro = true;
    } */

    /* let isDarkMode = JSON.parse((await (this.Storage.get({key: 'jmpr_isDarkMode'}))).value);
    
    if(isDarkMode == true || isDarkMode == false) useUIStore().updateDarkMode(isDarkMode);
    else window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? useUIStore().updateDarkMode(true) : useUIStore().updateDarkMode(false);

    await this.Storage.set({
      key: "jmpr_isDarkMode",
      value: this.isDarkMode,
    });
    
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', async event => {
      event.matches ? useUIStore().updateDarkMode(true) : useUIStore().updateDarkMode(false);
      await this.Storage.set({
        key: "jmpr_isDarkMode",
        value: this.isDarkMode,
      });
    })
    window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', async event => {
      event.matches ? useUIStore().updateDarkMode(false) : useUIStore().updateDarkMode(true);
      await this.Storage.set({
        key: "jmpr_isDarkMode",
        value: this.isDarkMode,
      });
    }) */

    window.addEventListener('offline', function(e) { document.body.style.backgroundColor = "whitesmoke"; });

    window.addEventListener('online', function(e) { document.body.style.backgroundColor = "initial"; });

    /* document.addEventListener('restartIntro', () => {
      this.showIntro = true;
    }) */

    document.addEventListener('openReportIssue', () => {
      this.showReportIssue = true;
    })

    document.addEventListener('pingingLiveChat', () => {
      this.newChat = true;
    })
    document.addEventListener('openedLiveChat', () => {
      this.newChat = false;
    })

    // Force logout - when user is deleted or sessions are revoked
    document.addEventListener('force-logout', async () => {
      useUIStore().updateToast({
        open: true,
        message: "Your account permissions have been updated. Please log in again.",
        type: "warning",
        duration: 5000
      });
      // Delay logout so user can read the toast message
      setTimeout(async () => {
        await useAuthStore().logoutUser();
        this.$router.push("/login");
      }, 5000);
    })
  },
  data() {
    return {
      showTooltip: false,
      tooltipStyle: {},
      tooltipSlot: null,
      tooltipHovered: false,
      offlineMode: false,
      switchAccountMode: false,
      proTrialPeriodIsOn: false,
			upgradeToProVisible: false,
			userRolesLimit: 0,
			botBuilderActiveBotsLimit: 0,
			crmCustomersLimit: 50,
      showIntro: false,
      showReportIssue: false,
      newIssue: {
        subject: undefined,
        name: undefined,
        description: undefined,
        images: []
      },
      uploadingImage: false,
      closeSideBar: true,
      commonLoader: true,
      expand: undefined,
      version: packageJson.version,
      newChat: false,
      salesChannelMenu: [
        {
          key: 'whatsapp',
          title: 'WhatsApp',
          route: '/sales-channel/whatsapp'
        },
        {
          key: 'googlercs',
          title: 'Google RCS',
          route: '/sales-channel/google-rcs'
        },
        {
          key: 'vonagesms',
          title: 'SMS',
          route: '/sales-channel/sms'
        },
        // Hidden from UI — accessible via direct URL for internal testing
        // {
        //   key: 'vonageemail',
        //   title: 'Email',
        //   route: '/sales-channel/email'
        // }
      ],
      screenshotFile: null,
      loadingJiraIssue: false,
      generatingPreview: false
    }
  },
  setup() {
    const route = useRoute();
    const authStore = useAuthStore();
    const uiStore = useUIStore();
    const { loginStatus, authData } = storeToRefs(authStore);
    const accounts = computed(() => authStore.getMultipleAccounts);
    const { toast, loadingMessage, isLoading } = storeToRefs(uiStore);
    const { roleDetails } = useRoleDetails();
    return {
      isSelected: url => url === route.path ? 'selected' : '',
      loginStatus,
      accounts,
      authData,
      toast,
      loadingMessage,
      isLoading,
      roleDetails,
    };
  },
  computed: {
    user() { return useAuthStore().cleanUserData; },
    getShopLogoImage() { return _getShopLogoImage(this.user); },
    authKey() { return useAuthStore().authData.authkey; },
    permissions() { return useAuthStore().getPermissions; },
    isAdmin() { return useAuthStore().isAdmin; },
    isLoggedIn() { return useAuthStore().isLoggedIn; },
    isLoggedInViaSSO() { return useAuthStore().isLoggedInViaSSO; },
    isPlatformLiteVersion() { return useAuthStore().isPlatformLiteVersion; },
    isDarkMode: {
      get() {
        return useUIStore().isDarkMode;
      },
      async set(value) {
        useUIStore().updateDarkMode(value);
      }
    },
    salesChannelMenuToShow() {
      return this.salesChannelMenu.filter(e => this.canAccessPath(e.route));
    },
    thisRouterPath() {
      return this.$route.path;
    },
    steps() {
      const isMobile = window.innerWidth <= 768;
      var steps = [
        {
          title: "Welcome to our new Dashboard 🤩",
          description: "I am Jumpman to assist you with what's new! Please press next to continue.\n\nYou can skip the intro by pressing close button and restart whenever you feel like. 🫣",
          element: "restart-intro"
        },
        {
          title: "Menu",
          description: this.closeSideBar ? "We have collapsed all the menu items here, to see the items please press next. 😇" : "You can collapse the menu, if you need more working space. 😇",
          element: isMobile ? "mobile-menu-button" : (this.closeSideBar ? "app-menu" : "menu-button"),
          func: () => {
            if (isMobile) {
              this.openMenu();
            } else {
              this.closeSideBar = !this.closeSideBar;
            }
          }
        },
        {
          title: "Language Changer",
          description: "Now you can use Jumper in any language you prefer 😎.",
          element: "google_translate_element_wrapper"
        },
        {
          title: "Dark mode",
          description: `Use Jumper in light/dark mode as you like! 😁`,
          element: "dark-mode",
          func: async () => {
            useUIStore().updateDarkMode(!this.isDarkMode);
          },
          prevFunc: () => {
            if (isMobile) {
              this.openMenu();
            } else {
              this.closeSideBar = !this.closeSideBar;
            }
          }
        },
        {
          title: "Finish",
          description: "We are working with blazing fast speed to provide you with more updates. 🥷\n\nThank you for your business ✌️",
          prevFunc: () => {
            useUIStore().updateDarkMode(!this.isDarkMode);
          }
        }
      ]

      return steps;
    }
  },
  watch: {
    $route(to) {
      if (to.path === '/page-inbox') {
        let width = window.innerWidth;
        if(width >= 992) this.closeSideBar = true;
      }
    },
    async isDarkMode() {
      if(this.isDarkMode) {
        document.body.classList.toggle('dark', true);
        document.body.classList.toggle('light', false);
      } else {
        document.body.classList.toggle('dark', false);
        document.body.classList.toggle('light', true);
      }
      await Storage.set({
        key: "jmpr_isDarkMode",
        value: this.isDarkMode
      });
    }
  },
  methods: {
    environment,
    /**
     * Put the presented toast into the browser's native top layer so it paints
     * above an open Vivid modal dialog (which uses <dialog>.showModal()).
     * Called on willPresent, i.e. after Ionic has teleported the element to
     * <ion-app> — promoting it earlier would be undone by that move.
     */
    promoteToastToTopLayer() {
      const el = this.$refs.globalToast?.$el ?? this.$refs.globalToast;
      if (!el || typeof el.showPopover !== 'function') return;
      try {
        // Leave and re-enter so we are the newest entry in the top layer, which
        // is what makes us paint above a dialog that was opened first.
        if (el.matches(':popover-open')) el.hidePopover();
        el.showPopover();
      } catch (error) {
        // Not connected / invalid state — the toast still renders, just lower.
      }
    },
    demoteToastFromTopLayer() {
      const el = this.$refs.globalToast?.$el ?? this.$refs.globalToast;
      if (!el || typeof el.hidePopover !== 'function') return;
      try {
        if (el.matches(':popover-open')) el.hidePopover();
      } catch (error) {
        // Already detached by Ionic, which removes it from the top layer too.
      }
    },
    canAccessPath(path) {
      return canAccessRoutePath(this.$router, path, useAuthStore());
    },
    canAccessAnyPath(paths = []) {
      return paths.some(path => this.canAccessPath(path));
    },
    redirectToHome() { this.$router.replace({ path: '/dashboard', query: null }); },
    closeToast(){
      useUIStore().updateToast({open: false});
    },
    async handleImageUpload(urlData) {
      try {
        this.uploadingImage = true;
        this.newIssue.images = urlData;
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.uploadingImage = false;
      }
    },
    async captureScreenshot() {
      try {
        this.generatingPreview = true;

        const canvas = await html2canvas(document.body);
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
        this.screenshotFile = new File([blob], 'screenshot.png', { type: 'image/png' });

        // const previewUrl = URL.createObjectURL(this.screenshotFile);
        const imgData = canvas.toDataURL('image/png');
        // this.newIssue.images = [{ url: imgData }];

        this.newIssue.images = [
          {
            url: imgData,
            file: this.screenshotFile
          }
        ];
      } catch (error) {
        console.error("Error capturing screenshot:", error);
        useUIStore().updateToast({
          open: true,
          message: "Failed to capture screenshot",
          type: "danger"
        });
      } finally {
        this.generatingPreview = false;
      }
    },
    async logout(){
      useUIStore().updateLoading({ isLoading: true, message: 'Logging out...' });
        try {
          await useAuthStore().logoutUser();
          useUIStore().updateToast({
            open: true,
            message: "You've successfully logged out. See you back soon! 👋🏼",
            type: "secondary"
          })
          useUIStore().updateLoading({ isLoading: false });
          this.$router.go("/login");
        } catch (error) {
          console.error(error);
        } finally {
          useUIStore().updateLoading({ isLoading: false });
      }
    },
    login(){
      this.$router.push("/login"); 
    },
    openMenu() {  // Intro mobile sidebar opening
      const menuToggle = this.$refs.menuToggle;
      if (menuToggle) {
        const buttonInsideToggle = menuToggle.$el.querySelector('ion-button');
        if (buttonInsideToggle) {
          buttonInsideToggle.click();
        }
      }
    },
    async chooseLoginAccount (shop_name) {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Switching account...' });
        this.newChat = false;
        // Navigate home first so inbox conversation components unmount before
        // the new account token is set, preventing stale conversation API calls.
        this.redirectToHome();
        await useAuthStore().clearAccountData();
        await useAuthStore().loginUser({shop_name});
        const response = await useAuthStore().checkToken();
        if(response) {
          useUIStore().updateToast({ open: true, message: "Welcome Back, You are successfully logged in!", type: "success" });
        }
      } catch (error) {
        console.log("Exception: ", error);
        useUIStore().updateToast({ open: true, message: "Something went wrong", type: "danger" });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.switchAccountMode = false;
      }
    },
    showTooltipFn({slot, icon, show = true}){
      if(!show) {
        if (!this.tooltipHovered)
          this.showTooltip = false;
        return;
      }
      this.showTooltip = true;
      this.tooltipSlot = slot;
      const p = icon.getBoundingClientRect();

      let top, left;

      const tooltipStyle = {};

      switch (this.side) {
        case 'bottom':
        default:
          top = p.top + p.height;
          left = p.left;
          break;
      }
      tooltipStyle.top = `${top}px`;
      tooltipStyle.left = `${left}px`;
      
      const margin = 10;
      this.$nextTick(() => {
        const box = this.$refs[`tooltip`].getBoundingClientRect();

        if (top + box.height > window.innerHeight)
          top = window.innerHeight - box.height - margin;
        if (left + box.width > window.innerWidth)
          left = window.innerWidth - box.width - margin;

        tooltipStyle.top = `${top}px`;
        tooltipStyle.left = `${left}px`;
        this.tooltipStyle = tooltipStyle;
      })
    },
    resetReportJiraIssueForm() {
      this.showReportIssue = false;
      this.newIssue = {
        subject: undefined,
        name: undefined,
        description: undefined,
        images: []
      }
      this.screenshotFile = null;
    },
    async submitJiraIssue() {
      try {
        this.loadingJiraIssue = true;

        const file = this.screenshotFile;

        // Create FormData
        const formData = new FormData();
        formData.append('summary', this.newIssue.subject);
        formData.append('description', this.newIssue.description);
        formData.append('reported_by', this.newIssue.name);
        formData.append('url', window.location.href);
        formData.append('shopname', useAuthStore().cleanUserData?.shopName);
        formData.append('user', useAuthStore().cleanUserData?.email);
        formData.append('frontend_version', this.version);
        formData.append('attachment', file);

        for (const [key, value] of formData.entries()) {
          console.log(`${key}:`, value);
        }
        // API call
        const response = await apiInterceptor.post(environment('VUE_APP_API_URL') + 'jira/issue', formData, { headers: { "Content-Type": "multipart/form-data" } } );

        if (response.id) {
          useUIStore().updateToast({
            open: true,
            message: `Issue submitted! You can track it here: ${response.jira_url}`,
            type: 'success',
            duration: 6000
          });
          this.resetReportJiraIssueForm();
        } else {
          useUIStore().updateToast({ open: true, message: 'Failed to submit issue', type: 'danger' });
        }
      } catch (error) {
        console.error("Error submitting Jira issue:", error);
        useUIStore().updateToast({ open: true, message: 'Failed to submit issue', type: 'danger' });
      } finally {
        this.loadingJiraIssue = false;
      }
    }
  },
  provide(){
    return {
      showTooltipFn: this.showTooltipFn
    }
  }
});
</script>

<style lang="scss" scoped>
/*
  The global toast carries popover="manual" so it can be promoted into the
  native top layer (see promoteToastToTopLayer). Neutralise the UA popover
  styles that would otherwise draw a bordered Canvas-coloured box around it —
  ion-toast supplies its own geometry via its shadow :host rules.
*/
ion-toast[popover] {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  overflow: visible;
  max-width: none;
  max-height: none;
}

.jira-loader-overlay {
  position: fixed;
  top: 0; /* to avoid overlapping ion-header */
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.8); /* semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

ion-content.overflow-hidden::part(scroll) {
  overflow: hidden !important;
}

.tooltip-box {
  position: fixed;
  z-index: 99999;
  transition: opacity 0.15s ease-in-out;
  text-wrap: wrap;
}
// Fade transition
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.sideNav {
  --side-width: 280px;
  --side-min-width: 60px;
}
.sideNav .label, .sideNav .icon {
  cursor: pointer;
}
.sideNav .icon {
  width: 25px;
  margin-right: 25px;
  &.image-icon {
    margin-inline-end: 32px;
  }
}
#inbox-list {
  height: 100dvh;
  padding-top: 0;
  padding-bottom: 0;
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#inbox-list .outer-list {
  padding: 5px 0px 10px 14px;
  margin-bottom: 5px;
  cursor: pointer;
}
#inbox-list .complete-list {
  overflow-y: auto;
  height: 100%;
}
.dark-mode {
  border-top: 1px solid var(--ion-color-step-150, #d7d8da);
  padding: 5px 0px;
  width: 100%;
}
.dark-mode ion-label {
  display: flex;
  flex-direction: column;
}
.outer-version {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  .version {
    font-size: 10px;
    opacity: 0.8;
    padding: 2px;
  }
}
.version {
  font-size: 12px;
  opacity: 0.8;
  padding: 5px;
}
.customer-profile{
  overflow: hidden;
  display: flex;
  border-top: 1px solid var(--background-primary);
  padding: 5px 12px;
  width: 100%;
  gap: 10px;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  .profile {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    cursor: pointer;
    .cust-img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      max-width: none;
      @include mobile {
        width: 30px;
        height: 30px;
      }
      @include tablet {
        width: 30px;
        height: 30px;
      }
    }
    .description {
      width: 200px;
      display: flex;
      flex-direction: column;
      gap: 5px;
      text-wrap: nowrap;
      .shopName {
        font-size: 0.875rem;
        font-weight: bold;
      }
      .email {
        font-size: 0.8rem;
      }
      .shopName, .email {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .icon {
    font-size: 1.5rem;
    cursor: pointer;
  }
}
ion-menu.md ion-item.active-link {
  color: var(--purple);
}
ion-menu.md ion-item {
  color: var(--gray-04);
}
.active-link {
  color: var(--purple);
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.sidebar-title {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--gray-04);
}
.sidebar-children{
  margin-left: 30px;
  padding-left: 25px;
  border-left: 1px solid var(--gray-04);
}
.sidebar-children-text{
  margin: 10px 0px 20px 15px;
}
.description h2 {
  display: inline;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--black);
} 
.description p {
  display: inline;
  color: var(--gray-04);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}
.sideIcons{
  margin: 0px;
}
.sideBarShopLogo{
  border-top: 1px solid var(--background-primary);
  display: flex;
  justify-content: center;
  padding-top: 10px;
}
.sideBarShopLogo img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
ion-menu.sideMenu{
  /* border-right: 1px solid var(--background-primary); */
  transition: width 700ms;
}
.upgrade-url {
  cursor: pointer;
  color: var(--purple);
  font-size: 12px;
  margin-left: 15px;
}
.disabled ion-label {
  opacity: 0.4;
}
.tooltip_container .tooltip_text.left {
  top: 5%;
  z-index: 999;
}
.intro-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  transition: all .3s ease-out;
}
.header {
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: var(--black);
}
ion-textarea.sctn-input{
  background: var(--background-primary);
  border-radius: 5px;
  --padding-start: 10px;
}
.title.shop, .sub-title.shop {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}
.sub-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--gray-04);
}
.cust-margin{
  margin-right: 10px;
}
.bttnSecondary {
  width: 100%;
  --background: var(--background-primary);
  --color: var(--black);
  --box-shadow: none;
  --border-radius: 5px !important;
  --border-width: 1px;
  height: 40px;
}
.uploadBttn{
  color: var(--purple);
  --border-color: var(--purple);
}
.custMargin{
  margin-right: 10px;
}


@media screen and (min-width: 992px) {
  .sideNavClosed {
    --side-width: 50px;
  }
  .sideNavClosed ion-item {
    --inner-padding-end: 0;
  }
  .sideNavClosed ion-item {
    margin-inline-end: 0;
  }
  .sideNavClosed .label {
    display: none;
  }
  .sideNavClosed .sidebar-children {
    display: none;
  }
}

/* Hide elements on mobile (< tablet/md breakpoint) */
@media (max-width: 991px) {
  .hide-on-mobile {
    display: none !important;
  }
}

.promotionAccordion {
  --background: var(--background-primary);
  border-radius: 50px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  &:hover {
    --background: var(--purple);
  }
}
ion-item.promotionAccordion:hover .title, ion-item.promotionAccordion:hover .sub-title, ion-item.promotionAccordion:hover .forwardIcon {
  color: var(--white);
}
ion-header {
  box-shadow: none;
  border-bottom: 1px solid var(--background-primary);
}
.redDot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: var(--ion-color-danger);
}
.offlineModalWrapper {
  --width: 430px !important;
  --height: 250px;
  --border-radius: 8px;
  z-index: 99999 !important;
  &.isPlatformLiteVersion {
    --height: 180px;
    z-index: 9999 !important;
    .sub-text {
      margin-top: 10px;
      &.danger {
        font-size: 0.9rem;
        a {
          color: var(--ion-color-danger);
        }
      }
    }
  }
  .offlineModal {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    align-content: center;
    justify-content: center;
    padding: 20px;
    border-radius: 5px;
    background-color: var(--white);
    text-align: center;
    .image {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 20px;
      img {
        width: 120px;
      }
    }
    .heading {
      font-size: 1.4rem;
      font-weight: bold;
      color: var(--black);
      margin-bottom: 20px;
    }
    .sub-text {
      font-size: 0.9rem;
      color: var(--gray-04);
      a {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
.showReportIssueModal {
  .item-col {
    padding: 10px 0;
    width: 100%;
    ion-label {
      padding-bottom: 10px;
    }
    .images {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 20px;
      align-items: flex-start;
      align-content: flex-start;
      .img {
        width: 250px;
        border-radius: 8px;
        position: relative;
        border-radius: 8px;
        .delete-icon {
          position: absolute;
          top: 5px;
          right: 5px;
          color: var(--ion-color-danger);
          background-color: var(--ion-color-white);
          padding: 5px;
          border-radius: 2px;
          cursor: pointer;
        }
      }
    }
  }
}
.header {
  color: var(--black);
  font-size: 18px;
  font-weight: 400;
}
ion-header {
  box-shadow: none;
  border-bottom: 1px solid var(--background-primary);
}
.info-box{
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  background: var(--purple-opac);
  padding: 10px;
  border-radius: 5px;
  margin: 10px 15px 10px 15px;
}
.info-text{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
</style>